<template>
    <div class="evn-domains">
        <template v-for="(item, index) in list">
            <el-tag v-if="$opt.switchStr(item, channelOption, 'code', 'name')" class="x-overflow-hidden" type="info" :key="index" size="mini">{{$opt.switchStr(item, channelOption, 'code', 'name')}}</el-tag>
        </template>
    </div>
</template>

<script>
    export default {
      props: {
        list: {
          type: Array,
          default: () => {
            return [];
          }
        },
        channelOption: {
          type: Array,
          default: () => {
            return [];
          }
        }
      },
    };
</script>

<style lang="scss" scoped>
    .evn-domains {
        display: flex;
        flex-direction: column;

        .el-tag--mini {
            box-sizing: border-box;
            height: auto;
            padding: 2px 5px;
            margin-bottom: 10px;

            &:last-child {
                margin-bottom: 0;
            }
        }
    }
</style>